module.exports = __webpack_public_path__ + "static/media/LoginImage.4b1281eb.png";